import React from 'react';
import { Button, Grid, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';

import axiosInstance, { EVENT_ID, getUserID, WEB_API } from '../constatns';
import Table from '../components/Table/Table';

import SpeakerSubmissionConfirm from '../speaker/SpeakerSubmissionConfirm';
import SpeakerSubmissionForm from '../speaker/SpeakerSubmissionForm';

class SpeakerTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      showReview: false,
      showMod: false,
      paperInfo: {},
      paperId: '',
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleMode = this.handleMode.bind(this);
    this.handleState = this.handleState.bind(this);
  }

  componentDidMount() {
    this.getSpeakerList();
    if (this.props.pid) {
      if (this.props.showType === 'review') {
        this.setState({ paperId: this.props.pid, showReview: true, paperInfo: this.props.pdata });
      } else {
        this.setState({ paperId: this.props.pid, showMod: true, paperInfo: this.props.pdata });
      }
    }
  }

  getSpeakerList() {
    axiosInstance(`${WEB_API}/speaker/my?eventId=${EVENT_ID}&userId=${getUserID(true).replace(`${EVENT_ID}_`, '')}`).then((res) => {
      let _data = res.data;
      // console.log(_data);
      _data.sort((a, b) => {
        if (a.id < b.id) {
          return -1;
        } else if (a.id > b.id) {
          return 1;
        } else {
          return 0;
        }
      });
      this.setState({ data: _data });
    });
  }

  openReviewPage(id, item, showType) {
    // console.log('선택항목: ', item);
    if (this.props.isHome) {
      this.props.handleTab(4, id, item, showType);
    } else {
      if (showType === 'review') {
        this.setState({
          paperId: id,
          paperInfo: item,
          showReview: true,
          showMod: false,
        });
      } else {
        this.setState({
          paperId: id,
          paperInfo: item,
          showReview: false,
          showMod: true,
        });
      }
    }
  }

  handleState = (type, value) => {
    this.setState(() => ({ [type]: value }));
  };

  handleMode() {
    this.setState({ showReview: false, showMod: true });
  }

  handleClose() {
    this.getSpeakerList();
    this.setState({ showReview: false, showMod: false });
  }

  render() {
    const { data, showReview, showMod } = this.state;

    return (
      <Grid container>
        {!showMod && !showReview && (
          <Grid item xs={12}>
            {this.props.showNewBtn && (
              <Button
                variant="contained"
                color="primary"
                size="small"
                disableElevation
                onClick={() => this.props.movePage('/speaker/submission')}
                style={{ marginBottom: 10 }}
              >
                Make a new submission
              </Button>
            )}
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell width="10%">No</TableCell>
                  <TableCell width="20%">Abstract No.</TableCell>
                  <TableCell width="40%">Abstract Title</TableCell>
                  <TableCell width="10%">Status</TableCell>
                  <TableCell width="20%">Review / Modify</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data.length > 0 ? (
                  data.map((item, idx) => {
                    return (
                      <TableRow key={`abstract-data-${idx}`}>
                        <TableCell align="center">{idx + 1}</TableCell>
                        <TableCell align="center">{item.speakerRegNo}</TableCell>
                        <TableCell>{item.noteTitle}</TableCell>
                        <TableCell align="center">
                          {item.status ? (
                            item.status === 'Complete' ? (
                              <span style={{ color: 'blue' }}>{item.status}</span>
                            ) : (
                              <span style={{ color: 'red' }}>{item.status}</span>
                            )
                          ) : (
                            '-'
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                              variant="contained"
                              size="small"
                              color="primary"
                              disableElevation
                              onClick={() => this.openReviewPage(item.id, item, 'review')}
                            >
                              Review
                            </Button>
                            {item.status && item.status !== 'Complete' ? (
                              <>
                                <div style={{ width: '5px' }} />
                                <Button
                                  variant="contained"
                                  size="small"
                                  color="primary"
                                  disableElevation
                                  onClick={() => this.openReviewPage(item.id, item, 'mod')}
                                >
                                  Modify
                                </Button>
                              </>
                            ) : null}
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No submission
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Grid>
        )}
        {showReview && (
          <SpeakerSubmissionConfirm
            mode={'review'}
            isMypage={true}
            abstractId={this.state.paperId}
            data={this.state.paperInfo}
            handleMode={this.handleMode}
            handleClose={this.handleClose}
          />
        )}
        {showMod && (
          <SpeakerSubmissionForm
            mode={'modify'}
            isMypage={true}
            abstractId={this.state.paperId}
            data={this.state.paperInfo}
            handleClose={this.handleClose}
            isPop={true}
            handleState={this.handleState}
          />
        )}
      </Grid>
    );
  }
}

export default SpeakerTable;
